import { BaseInfoModel } from 'app/core/models';

const treatmentDetailsImagePrefix = `assets/images`;

export const MomentSubtypeOptions: BaseInfoModel[] = [
  {
    name: 'general.hollywoodAsTitle',
    id: 90,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/hollywood.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.hollywoodDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.hollywoodPoint1', 'messages.hollywoodPoint2'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
  {
    name: 'general.enhancedAsTitle',
    id: 91,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/enchanced.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.enhancedDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.enhancedPoint1', 'messages.enhancedPoint2'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
  {
    name: 'general.vigorousAsTitle',
    id: 92,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/vigorous.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.vigorousDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.vigorousPoint1', 'messages.vigorousPoint2'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
  {
    name: 'general.softenedAsTitle',
    id: 93,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/softened.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.softenedDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.softenedPoint1', 'messages.softenedPoint2'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
  {
    name: 'general.youthfulAsTitle',
    id: 94,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/youthful.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.youthfulDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.youthfulPoint1', 'messages.youthfulPoint2'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
  {
    name: 'general.matureAsTitle',
    id: 95,
    imagePath: `${treatmentDetailsImagePrefix}/treatment-sub-type/mature.webp`,
    hasInfo: true,
    tooltip: {
      active: false,
      title: 'general.matureDesignStyle',
      body: {
        sections: [
          {
            description: '',
            bullets: ['messages.maturePoint1', 'messages.maturePoint2', 'messages.maturePoint3'],
          },
        ],
      },
      placement: 'top',
      cssClass: 'sub-type-tooltip',
    },
  },
];
